import { render, staticRenderFns } from "./ThePageComponentCategoryFeatured.vue?vue&type=template&id=392465f4&"
import script from "./ThePageComponentCategoryFeatured.vue?vue&type=script&lang=js&"
export * from "./ThePageComponentCategoryFeatured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392465f4')) {
      api.createRecord('392465f4', component.options)
    } else {
      api.reload('392465f4', component.options)
    }
    module.hot.accept("./ThePageComponentCategoryFeatured.vue?vue&type=template&id=392465f4&", function () {
      api.rerender('392465f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/ThePageComponentCategoryFeatured.vue"
export default component.exports